// Browser side of a voice call: microphone → 16 kHz PCM over WebSocket, agent audio played back.
const WORKLET =
  "class C extends AudioWorkletProcessor{constructor(o){super();this.r=o.processorOptions.rate;this.b=[];this.acc=0}" +
  "process(i){var c=i[0]&&i[0][0];if(!c)return true;var step=this.r/16000;for(var n=0;n<c.length;n++){this.acc+=1;if(this.acc>=step){this.acc-=step;" +
  "var s=Math.max(-1,Math.min(1,c[n]));this.b.push(s<0?s*32768:s*32767)}}if(this.b.length>=320){var a=new Int16Array(this.b);this.b=[];" +
  "var e=0;for(var k=0;k<a.length;k++)e+=Math.abs(a[k]);this.port.postMessage({buf:a.buffer,level:e/a.length/32768},[a.buffer])}return true}}registerProcessor('cap',C)";

export async function startVoiceCall(wsUrl, { onEvent, onLevel, onClose } = {}) {
  const stream = await navigator.mediaDevices.getUserMedia({
    audio: { echoCancellation: true, noiseSuppression: true, autoGainControl: true },
  });
  const ctx = new (window.AudioContext || window.webkitAudioContext)();
  const url = URL.createObjectURL(new Blob([WORKLET], { type: "application/javascript" }));
  await ctx.audioWorklet.addModule(url);
  const node = new AudioWorkletNode(ctx, "cap", { processorOptions: { rate: ctx.sampleRate } });
  ctx.createMediaStreamSource(stream).connect(node);
  const ws = new WebSocket(wsUrl);
  ws.binaryType = "arraybuffer";
  let sources = [];
  let cursor = 0;
  let closed = false;

  const clear = () => {
    sources.forEach((s) => { try { s.stop(); } catch (e) {} });
    sources = [];
    cursor = ctx.currentTime;
  };
  const play = (buf) => {
    const i16 = new Int16Array(buf);
    const f = new Float32Array(i16.length);
    for (let i = 0; i < i16.length; i++) f[i] = i16[i] / 32768;
    const ab = ctx.createBuffer(1, f.length, 16000);
    ab.copyToChannel(f, 0);
    const src = ctx.createBufferSource();
    src.buffer = ab;
    src.connect(ctx.destination);
    const t = Math.max(ctx.currentTime + 0.05, cursor);
    src.start(t);
    cursor = t + ab.duration;
    sources.push(src);
    src.onended = () => { sources = sources.filter((x) => x !== src); };
  };
  const stop = () => {
    if (closed) return;
    closed = true;
    try { if (ws.readyState === 1) ws.send(JSON.stringify({ type: "hangup" })); } catch (e) {}
    try { ws.close(); } catch (e) {}
    try { stream.getTracks().forEach((t) => t.stop()); } catch (e) {}
    setTimeout(() => { try { ctx.close(); } catch (e) {} }, 300);
    onClose && onClose();
  };

  node.port.onmessage = (e) => {
    if (ws.readyState === 1) ws.send(e.data.buf);
    onLevel && onLevel(e.data.level);
  };
  ws.onmessage = (e) => {
    if (typeof e.data !== "string") { play(e.data); return; }
    let m;
    try { m = JSON.parse(e.data); } catch (err) { return; }
    if (m.type === "clear") clear();
    if (m.type === "end") setTimeout(stop, 1500);
    onEvent && onEvent(m);
  };
  ws.onclose = () => { if (!closed) setTimeout(stop, 1200); };
  ws.onerror = () => onEvent && onEvent({ type: "error", message: "Connection to the voice server failed." });
  return { stop };
}
